import * as React from "react";
import { useSelector } from "react-redux";
import { Tab, Container, Menu } from "semantic-ui-react";

import { ohCaseSelector, previewConversationSelector, routeCustomersSelector, routeIdSelector, subjectSelector } from "@teamprevent/common/messaging/selectors";

import { CaseConversation } from "./CaseConversation";
import { CaseConversationTabLabel } from "./CaseConversationTabLabel";

const CaseConversationTabContent: React.FunctionComponent = () => {

    const ohCaseId = useSelector(routeIdSelector);
    const ohCase = useSelector(ohCaseSelector);
    const employeeName = `${ohCase?.employeeFirstName} ${ohCase?.employeeLastName}`;
    const customerId = useSelector(routeCustomersSelector);
    const previewConversation = useSelector(previewConversationSelector);
    const subject = useSelector(subjectSelector);

    return (
        <Container>
            <CaseConversation
                caseId={ohCaseId}
                subject={subject}
                includeAllSubjects={true}
                showReply={true}
                customerId={customerId}
                previewConversation={!!(previewConversation)}
                employeeName={employeeName}
            />
        </Container>
    );
};

export const caseConversationTab = (ohCaseId: string) => ({
    path: "/conversation",
    menuItem: (
        <Menu.Item key='conversation'>
            Conversation <CaseConversationTabLabel ohCaseId={ohCaseId} />
        </Menu.Item>
    ),
    render: () => <Tab.Pane><CaseConversationTabContent /></Tab.Pane>
});
